/**
 * ScreenCheck Portal API
 * ScreenCheck Portal REST API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The MachineFileRevisionMeta model module.
 * @module model/MachineFileRevisionMeta
 * @version 0.0.1
 */
class MachineFileRevisionMeta {
    /**
     * Constructs a new <code>MachineFileRevisionMeta</code>.
     * @alias module:model/MachineFileRevisionMeta
     */
    constructor() { 
        
        MachineFileRevisionMeta.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>MachineFileRevisionMeta</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/MachineFileRevisionMeta} obj Optional instance to populate.
     * @return {module:model/MachineFileRevisionMeta} The populated <code>MachineFileRevisionMeta</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new MachineFileRevisionMeta();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('machine_id')) {
                obj['machine_id'] = ApiClient.convertToType(data['machine_id'], 'Number');
            }
            if (data.hasOwnProperty('revision')) {
                obj['revision'] = ApiClient.convertToType(data['revision'], 'Number');
            }
            if (data.hasOwnProperty('author')) {
                obj['author'] = ApiClient.convertToType(data['author'], 'String');
            }
            if (data.hasOwnProperty('timestamp')) {
                obj['timestamp'] = ApiClient.convertToType(data['timestamp'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>MachineFileRevisionMeta</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>MachineFileRevisionMeta</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['author'] && !(typeof data['author'] === 'string' || data['author'] instanceof String)) {
            throw new Error("Expected the field `author` to be a primitive type in the JSON string but got " + data['author']);
        }
        // ensure the json data is a string
        if (data['timestamp'] && !(typeof data['timestamp'] === 'string' || data['timestamp'] instanceof String)) {
            throw new Error("Expected the field `timestamp` to be a primitive type in the JSON string but got " + data['timestamp']);
        }

        return true;
    }


}



/**
 * @member {Number} id
 */
MachineFileRevisionMeta.prototype['id'] = undefined;

/**
 * @member {Number} machine_id
 */
MachineFileRevisionMeta.prototype['machine_id'] = undefined;

/**
 * @member {Number} revision
 */
MachineFileRevisionMeta.prototype['revision'] = undefined;

/**
 * @member {String} author
 */
MachineFileRevisionMeta.prototype['author'] = undefined;

/**
 * @member {String} timestamp
 */
MachineFileRevisionMeta.prototype['timestamp'] = undefined;






export default MachineFileRevisionMeta;

